module.exports = __webpack_public_path__ + "static/media/koolicar-pin-big.7e7a8c64.svg";